import React from 'react';
import { useForm, useWatch } from 'react-hook-form';

import { Button, FormSection, SelectField, TextareaField } from '@/components';
import { FundingOption } from '@/globalTypes';
import { DocumentWithComment } from './PlayerRequestDocumentsForm';

type AddDocumentFormValues = {
  document: FundingOption | null;
  comment: string;
};

type AddDocumentSectionProps = {
  fundingOptions: { label: string; value: string }[];
  onAddDocument: (document: DocumentWithComment) => void;
};

export const AddDocumentSection: React.FC<AddDocumentSectionProps> = ({
  fundingOptions,
  onAddDocument,
}) => {
  const addDocumentMethods = useForm<AddDocumentFormValues>({
    defaultValues: {
      document: null,
      comment: '',
    },
  });

  const watchedDocument = useWatch({
    control: addDocumentMethods.control,
    name: 'document',
  });

  const handleAddDocument = (values: AddDocumentFormValues) => {
    if (!values.document) {
      return;
    }

    onAddDocument({
      document: values.document,
      comment: values.comment,
    });

    addDocumentMethods.reset({
      document: null,
      comment: '',
    });
  };

  return (
    <div className="border-t border-b border-grey-50 dark:border-gray-600 py-6">
      <FormSection methods={addDocumentMethods} className="grid gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <SelectField
            options={fundingOptions}
            name="document"
            id="AddDocumentForm__document"
            title="Document Type"
            required
          />
          <TextareaField
            name="comment"
            id="AddDocumentForm__comment"
            title="Comment (optional)"
            placeholder="Add a comment the player is going to see..."
          />
        </div>
        <div className="flex justify-end">
          <Button
            type="button"
            variant="secondary"
            disabled={!watchedDocument}
            onClick={addDocumentMethods.handleSubmit(handleAddDocument)}
          >
            Add Document
          </Button>
        </div>
      </FormSection>
    </div>
  );
};
